async function getRolesByCategory(categoria, excecao=1) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({categoria:categoria, excecao:excecao}),
  };
  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "OEC/papel/get_roles_by_category.php", requestOptions);

    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }

    const json = await response.json();
    if (json?.items) {
      return json;
    } else {
      throw new Error(`Erro de aplicação: status ${json.status}`);
    }

  } catch (error) {
    console.error("Erro ao buscar os dados: ", error.message);

    return {
      status: 400,
      error: error.message
    };
  }
}

export { getRolesByCategory };
